import { useEffect, useState } from "react";
import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  CircularProgress,
  FormHelperText,
} from "@mui/material";
import useGraphQLClient from "../hooks/useGraphQLClient";
import { READ_SELECTABLE_TENANTS } from "../graph/tenants/queries";

const TenantSelector = ({
  value,
  onChange,
  label = "Tenant",
  size = "small",
  minWidth = 220,
}) => {
  const client = useGraphQLClient();
  const [tenants, setTenants] = useState([]);
  const [loading, setLoading] = useState(false);
  const [loadError, setLoadError] = useState("");

  useEffect(() => {
    let isMounted = true;

    const fetchTenants = async () => {
      try {
        setLoading(true);
        setLoadError("");

        const res = await client.request(READ_SELECTABLE_TENANTS);

        if (!isMounted) return;

        const tenantList = res?.readAllSelectableTenants ?? [];
        setTenants(tenantList);
      } catch (err) {
        console.error("Failed to load tenants", err);
        if (!isMounted) return;
        setTenants([]);
        setLoadError("Failed to load tenants");
      } finally {
        if (isMounted) setLoading(false);
      }
    };

    fetchTenants();

    return () => {
      isMounted = false;
    };
  }, [client]);

  return (
    <FormControl
      variant="outlined"
      size={size}
      sx={{ minWidth }}
      error={!!loadError}
    >
      <InputLabel>{label}</InputLabel>
      <Select
        value={value || ""}
        onChange={(e) => onChange(e.target.value)}
        label={label}
        disabled={loading}
      >
        <MenuItem value="">
          <em>Select tenant</em>
        </MenuItem>

        {loading && (
          <MenuItem disabled>
            <CircularProgress size={18} />
          </MenuItem>
        )}

        {!loading &&
          tenants.map((tenant) => (
            <MenuItem key={tenant.id} value={tenant.id}>
              {tenant.name}
            </MenuItem>
          ))}
      </Select>

      {loadError && <FormHelperText>{loadError}</FormHelperText>}
    </FormControl>
  );
};

export default TenantSelector;